import { render, staticRenderFns } from "./assist-case-allot.vue?vue&type=template&id=77c2a24f&scoped=true"
import script from "./assist-case-allot.vue?vue&type=script&lang=ts"
export * from "./assist-case-allot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c2a24f",
  null
  
)

export default component.exports